import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../utils/axios";

export interface RackbeatState {
  hasIntegration: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: RackbeatState = {
  hasIntegration: false,
  isLoading: true,
  error: null,
};

export const checkRackbeatIntegration = createAsyncThunk(
  "rackbeat/checkIntegration",
  async () => {
    const { data } = await axios.get<{ has_integration: boolean }>(
      "/v1/integrations/rackbeat/status/",
    );
    return data.has_integration;
  },
);

const rackbeatSlice = createSlice({
  name: "rackbeat",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(checkRackbeatIntegration.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(checkRackbeatIntegration.fulfilled, (state, action) => {
        state.hasIntegration = action.payload;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(checkRackbeatIntegration.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || "Failed to check integration";
      });
  },
});

export default rackbeatSlice.reducer;
